/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserKrrInfoResponse
 */
export interface UserKrrInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof UserKrrInfoResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserKrrInfoResponse
     */
    mobileNr?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserKrrInfoResponse
     */
    canBeNotified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserKrrInfoResponse
     */
    isReserved?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserKrrInfoResponse
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UserKrrInfoResponse interface.
 */
export function instanceOfUserKrrInfoResponse(value: object): value is UserKrrInfoResponse {
    return true;
}

export function UserKrrInfoResponseFromJSON(json: any): UserKrrInfoResponse {
    return UserKrrInfoResponseFromJSONTyped(json, false);
}

export function UserKrrInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserKrrInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'mobileNr': json['mobileNr'] === undefined ? undefined : json['mobileNr'] === null ? null : json['mobileNr'],
        'canBeNotified': json['canBeNotified'] == null ? undefined : json['canBeNotified'],
        'isReserved': json['isReserved'] == null ? undefined : json['isReserved'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UserKrrInfoResponseToJSON(json: any): UserKrrInfoResponse {
    return UserKrrInfoResponseToJSONTyped(json, false);
}

export function UserKrrInfoResponseToJSONTyped(value?: UserKrrInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'mobileNr': value['mobileNr'],
        'canBeNotified': value['canBeNotified'],
        'isReserved': value['isReserved'],
        'isActive': value['isActive'],
    };
}

